export default function (state = {}, action) {
    switch (action.type) {
        case "OWNER_DATA":
            return action.payload;
            break;
        default:
            return state;
    }
}
